<template>
  <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack flex-wrap">
    <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
      <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t('breadcrumbs.shop.shops') }}</h1>
      <span class="h-20px border-gray-300 border-start mx-4"></span>
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 ">
        <li class="breadcrumb-item text-dark">{{ $t('shop.all_shops') }}</li>
      </ul>
    </div>
    <div class="d-flex align-items-center gap-2 gap-lg-3">
      <div class="d-flex align-items-center position-relative my-1">
        <span class="svg-icon svg-icon-1 position-absolute ms-6">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
              transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
            <path
              d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
              fill="currentColor" />
          </svg>
        </span>
        <input type="text" v-model="$parent.search" data-allow-clear="true"
          class="form-control form-control-sm form-control-solid w-250px ps-15"
          :placeholder="$t('contacts.placeholder.search')" />
      </div>
      <div class="d-flex flex-wrap my-1">
        <select name="filter" v-model="filter" data-control="select2" data-search="true" data-placeholder="Filter"
          class="form-select kt_select form-select-solid form-select-sm form-control-solid w-200px border-body me-5">
          <option v-for="filter in filterBy" :value="filter.value" :key="filter.value">{{ $t(filter.translate) }}</option>
        </select>
      </div>
      <div class="m-0" v-if="$can('boutique_create')">
        <span :title="!canCreate ? $t('shop.shop_limit_reached_hint') : ''" @click="!canCreate && showLimitHint()">
          <button :disabled="!canCreate" class="btn btn-sm btn-primary" @click="openCreateModal">{{ $t('button.add') }}</button>
        </span>
      </div>
      <div class="m-0">
        <button @click="$goBack" v-if="back" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder">
          <span class="svg-icon svg-icon-md">
            <i class="fas fa-backspace"></i>
          </span>{{ $t("back") }}
        </button>
      </div>
    </div>
    <!-- clic sur « Ajouter » grisé : pourquoi (limite de l'abonnement) -->
    <LimitReachedBanner
        v-if="showLimitBanner && !canCreate"
        class="w-100 mt-3"
        :message="$t('shop.shop_limit_reached_hint')"
        :ticket-message="$t('limit_banner.ticket_shops')"
        @close="showLimitBanner = false"
    />
  </div>
</template>

<script>
import LimitReachedBanner from '@/components/LimitReachedBanner.vue'

export default {
  components: { LimitReachedBanner },
  data() {
    return {
      filter: "all",
      showLimitBanner: false,
    }
  },
  props: {
    title: { required: true, type: String, default: 'Titre' },
    back: { required: false, type: Boolean, default: false },
    filterBy: { required : false , type: Array, default: [] },
    canCreate: { required: false, type: Boolean, default: true },
  },
  async mounted() {
    $('.kt_select').select2()
    $('.kt_select').change((e) => {
      switch (e.target.name) {
        case 'filter':
          this.filter = e.target.value
            this.$emit("update:filterBy", this.filter)
          break;
      }
    });
  },
  methods: {
    openCreateModal() {
      $('#createModal').modal('toggle')
    },
    showLimitHint() {
      this.showLimitBanner = true
    },
  }

}
</script>
